import { YearbookProductMatch } from '../types';

const named = (match?: YearbookProductMatch): match is Extract<YearbookProductMatch, { title: string }> => (
  Boolean(match && (match.status === 'linked' || match.status === 'matched' || match.status === 'catalog'))
);

export function athenaProductName(match?: YearbookProductMatch): string {
  return named(match) ? match.title.trim() : '';
}

export function athenaEan(match?: YearbookProductMatch): string {
  return named(match) ? match.ean?.trim() || '' : '';
}
